import styled, { css } from 'styled-components';
import { GlobalColors, GlobalFonts } from '../../globals';
import { Container } from '@mui/material';

export const ImgMenu = styled.img`
  margin-right: -8px;
  float: right;
  cursor: pointer;
`;

export const ContMenuMobile = styled(Container)`
  z-index: 100;
  width: 64px;
  height: 64px;
  padding: 0;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (min-width: 1024px) {
    display: none !important;
  }
`;

export const ContBodyMenuMobile = styled(Container)`
  position: fixed;
  width: 100%;
  height: calc(100vh - 64px);
  top: 64px;
  left: 0;
  padding: 0 !important;
  background: #0e57b6;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  overflow-y: auto;
`;

export const BodyMenuMobile = styled.div`
  width: 100%;
  min-height: 100%;
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  flex-direction: column;
`;

export const ContItemsMenuMobile = styled.div`
  width: 100%;
`;

export const ContItemsMenuMobileBtn = styled.div`
  width: 100%;
  margin-top: 18px;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: center;

  #BtnA {
    height: 52px !important;
    border-radius: 14px;
    font-size: 24px;
    font-weight: 600;
    padding: 0 14px;
  }

  #BtnA svg {
    margin-left: 6px;
  }
`;

export const ExpandIco = styled.img`
  width: 18px;
  transition: transform 0.2s ease;
  filter: brightness(0) invert(1);
  opacity: 0.95;
  ${props =>
    !props.isContentVisible &&
    css`
      transform: rotate(-180deg);
    `}
`;

export const ItemMenuMobile = styled.button`
  width: 100%;
  min-height: 48px;
  padding: 12px 10px;
  background-color: transparent;
  border: none;
  border-bottom: ${props => props.borderBottom === true ? 'none' : '1px solid rgba(206, 225, 248, 0.2)'};
  font-family: ${GlobalFonts.fontRegular};
  font-size: 20px;
  line-height: 1.2;
  font-weight: 600;
  color: ${GlobalColors.colorBtnTextSecondary};
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: left;

  @media (max-width: 390px) {
    font-size: 18px;
    min-height: 46px;
    padding: 11px 10px;
  }
`;

export const ListaServiciosMobile = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  overflow-y: auto;
  background: rgba(11, 79, 168, 0.35);
`;

export const ContItemMenuMobileServices = styled.div`
  display: flex;
  align-items: center;
`;

export const ContItemMenuMobileLenguagess = styled.div`
  display: block;
  align-items: center;
  width: 100%;
`;

export const ItemMenuMobileServices = styled.button`
  width: 100%;
  min-height: 40px;
  padding: 9px 16px 9px 26px;
  background-color: transparent;
  border: none;
  border-bottom: ${props => props.borderBottom === true ? '1px solid rgba(206, 225, 248, 0.2)' : 'none'};
  font-family: ${GlobalFonts.fontRegular};
  font-size: 20px;
  line-height: 1.3;
  font-weight: 600;
  color: #cfe2fb;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;

  & > img {
    width: 16px;
    height: 16px;
    filter: brightness(0) saturate(100%) invert(89%) sepia(11%) saturate(734%) hue-rotate(185deg) brightness(101%) contrast(97%);
  }

  @media (max-width: 390px) {
    font-size: 18px;
  }
`;

export const ContGLobe = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const LangCode = styled.span`
  font-family: ${GlobalFonts.fontRegular};
  font-size: 18px;
  font-weight: 600;
  color: #d8e7fb;
`;

export const ContFooterMenuMobile = styled.div`
  width: 100%;
  margin-top: 28px;
  padding: 10px 16px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 12px;
`;

export const LegalLinksMobile = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;

  a {
    color: #bcd5f7;
    font: 13px ${GlobalFonts.fontRegular};
    text-decoration: none;
    border-bottom: 1px solid rgba(188, 213, 247, 0.65);
    line-height: 1.2;
    padding-bottom: 1px;
  }
`;

export const SocialLinksMobile = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 22px;
`;

export const SocialLinkMobile = styled.a`
  width: 22px;
  height: 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  opacity: 0.95;

  img {
    width: 22px;
    height: 22px;
    filter: brightness(0) invert(1);
  }
`;
